module.exports = __webpack_public_path__ + "static/img/q3q_22.84815bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/q3q_22.jpg
// module id = 8Kal
// module chunks = 3